import { EYECOUNT, TCountingMethodType, TRAVERSE } from '../counting-method';
import { getAbundanceCategory } from './abundance-category';
import { FINALISING_FACTORS } from './finalising-factors';
import { getPhytoFactorRange } from './phyto-factor-ranges';

export function getAbundance(
  count: number | '+',
  countingMethod?: TCountingMethodType,
  sampleFactor?: number,

  /**
   * Phyto values are divided by two to get the category number. In some places, using this value
   * would be confusing, so in those cases pass `false` to return the factor-applied count without
   * dividing by two for phyto values.
   */
  dividePhytoByTwo = true,
) {
  if (count === '+') {
    return 43;
  }

  switch (countingMethod) {
    case 'EYECOUNT': {
      return getAbundanceCategory(count, EYECOUNT)[1];
    }

    case 'TRAVERSE': {
      if (!sampleFactor) {
        throw new TypeError('Cannot get abundance - missing sample factor');
      }

      return getAbundanceCategory(Math.round(count * sampleFactor), TRAVERSE)[1];
    }

    case 'PHYTO': {
      if (!sampleFactor) {
        throw new TypeError('Cannot get abundance - missing sample factor');
      }

      const factorRange = getPhytoFactorRange(sampleFactor);

      if (!factorRange) {
        throw new RangeError('Cannot get abundance - factor not in any range');
      }

      const [sampleFactorNormalised] = factorRange;

      const finalisingFactor = FINALISING_FACTORS.find(
        ([fields, factor]) => fields === count && factor === sampleFactorNormalised,
      );

      if (!finalisingFactor) {
        throw new RangeError('Cannot get abundance - could not determine finalising factor value');
      }

      let returnValue =
        sampleFactor <= 1 ? count - finalisingFactor[2] : count + finalisingFactor[2];

      if (dividePhytoByTwo) {
        returnValue /= 2;
      }

      return Math.round(returnValue);
    }

    default:
      throw new TypeError('Cannot get abundance - missing counting method');
  }
}
